import { useQuery } from '@tanstack/react-query';
import {
  IFSDirectory,
  IFsDirectoryFilterSettings,
  IFSScanResult,
} from '../../Interfaces/IFSDirectory';
import { customFetcher } from '../useFetch';
import { IFSDirectoryType } from '../../Interfaces/IFSDirectoryType';
import { IFSDirectoryProtocol } from '../../Interfaces/IFSDirectoryProtocol';
import { IFSDirectoryAuthentication } from '../../Interfaces/IFSDirectoryAuthentication';

export const useGetHasDirectory = (fileId: number) => {
  const { data: hasDirectory, isLoading: isLoadingHasDirectory } =
    useQuery<boolean>({
      refetchOnWindowFocus: false,
      queryKey: ['fsdirectory/hasDir', fileId],
      queryFn: () =>
        customFetcher({ endpoint: `/fsdirectory/hasDir/${fileId}` }),
    });

  return { hasDirectory, isLoadingHasDirectory };
};

export const useGetFsDirectoryTypes = () => {
  const { data: fsDirectoryTypes, isLoading: isLoadingFsDirectoryTypes } =
    useQuery<IFSDirectoryType[]>({
      queryKey: ['fsdirectorytype'],
      queryFn: () => customFetcher({ endpoint: '/fsdirectorytype' }),
    });

  return { fsDirectoryTypes, isLoadingFsDirectoryTypes };
};

export const useGetFsDirectoryProtocols = () => {
  const {
    data: fsDirectoryProtocols,
    isLoading: isLoadingFsDirectoryProtocols,
  } = useQuery<IFSDirectoryProtocol[]>({
    queryKey: ['fsdirectoryprotocol'],
    queryFn: () => customFetcher({ endpoint: '/fsdirectoryprotocol' }),
  });

  return { fsDirectoryProtocols, isLoadingFsDirectoryProtocols };
};

export const useGetFsDirectoryAuthentications = () => {
  const {
    data: fsDirectoryAuthentications,
    isLoading: isLoadingFsDirectoryAuthentications,
  } = useQuery<IFSDirectoryAuthentication[]>({
    queryKey: ['fsdirectoryauthentication'],
    queryFn: () => customFetcher({ endpoint: '/fsdirectoryauthentication' }),
  });

  return { fsDirectoryAuthentications, isLoadingFsDirectoryAuthentications };
};

export const useGetFsDirectories = () => {
  const { data: fsDirectories, isLoading: isLoadingFsDirectories } = useQuery<
    IFSDirectory[]
  >({
    queryKey: ['fsdirectory'],
    queryFn: () => customFetcher({ endpoint: '/fsdirectory' }),
  });

  return { fsDirectories, isLoadingFsDirectories };
};

export const useScanFsDirectories = (
  filterObject: IFsDirectoryFilterSettings
) => {
  const {
    data: fsScanResults,
    isLoading: isLoadingFsScanResults,
    isFetching: isFetchingFsScanResults,
    refetch: refetchFsScanResults,
  } = useQuery<IFSScanResult[]>({
    queryKey: ['fsdirectory/scan', filterObject],
    queryFn: () =>
      customFetcher({
        endpoint: '/fsdirectory/scan',
        body: filterObject,
        method: 'POST',
      }),
  });

  return {
    fsScanResults,
    isLoadingFsScanResults,
    refetchFsScanResults,
    isFetchingFsScanResults,
  };
};
